import axios from "axios";
import { BASE_URL } from "./endpoints";

const http = axios.create({
  baseURL: BASE_URL,
});

http.interceptors.response.use(
  (request) => {
    return request;
  },
  (error) => {
    if (error?.response?.status == "401") {
      localStorage.removeItem("userToken");
    }
    return Promise.reject(error);
  }
);

const setHeaders = (token) => {
  if (!token) return;
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
};

const Api = {
  getData: (url, token) => http.get("/api/" + url, setHeaders(token)),
  postData: (url, body, token) =>
    http.post("/api/" + url, body, setHeaders(token)),
  putData: (url, content, token) =>
    http.put("/api/" + url, content, setHeaders(token)),
  delete: (url, body, token) =>
    http.delete("/api/" + url, { data: body, ...setHeaders(token) }),
  patchData: (url, content, token) =>
    http.patch("/api/" + url, content, setHeaders(token)),
};

export default Api;
